import React from "react"

export default function Home() {
  return <div>minijo.dev | Hello World!</div>
}
